module.exports = __webpack_public_path__ + "img/recommended-ingredients-icon.b8e27874.svg";